// Copyright 2025, University of Maryland, All Rights Reserved
import { AlertCircle, CheckCircle2 } from 'lucide-react'

interface DashboardStatusProps {
  message?: string | null
  error?: string | null
}

/** Shows success/error messages for dashboard actions */
export const DashboardStatus: React.FC<DashboardStatusProps> = ({
  message,
  error,
}) => {
  const hasMessage = Boolean(message)
  const hasError = Boolean(error)

  if (!hasMessage && !hasError) {
    return null
  }

  return (
    <div className="mb-4 space-y-2 text-sm">
      {message ? (
        <div data-testid="cr-jobs-complete" className="flex items-start gap-2 rounded-md border border-emerald-300 bg-emerald-50 px-3 py-2 text-sm text-foreground dark:border-emerald-500/30 dark:bg-emerald-400/10">
          <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0 text-emerald-600 dark:text-emerald-400" />
          <span>{message}</span>
        </div>
      ) : null}

      {error ? (
        <div
          role="alert"
          data-testid="cr-dashboard-error"
          className="flex items-start gap-2 rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive dark:border-destructive/50 dark:bg-destructive/15 dark:text-destructive-foreground"
        >
          <AlertCircle className="mt-0.5 h-4 w-4 flex-shrink-0" />
          <span>{typeof error === 'string' ? error : JSON.stringify(error)}</span>
        </div>
      ) : null}
    </div>
  )
}
